module.exports = __webpack_public_path__ + "static/vive_studio_boy-781c58c92d4a1d467d4fa1ae5e8b74d2.png";